module.exports = __webpack_public_path__ + "static/media/v16.eddaaf36.mp4";